import React from 'react';
import { Link } from "react-router-dom";
import { home, urlUpdate, scheduleType } from "../../utils/routes";

const LeftMenu = () => {
    return (
        <div className="leftMenuOuter">
            <ul className="leftMenu">
                <li>
                    <Link to={home}> <i className="fa fa-life-ring"></i> Home </Link>
                </li>
                <li>
                    <Link to={urlUpdate}> <i className="fa fa-life-ring"></i> Stream Url </Link>
                </li>
                <li>
                    <Link to={scheduleType}> <i className="fa fa-clock-o"></i> Schedule </Link>
                </li>
                <li>
                    <a href="#"> <i className="fa fa-facebook"></i> Support Pin </a>
                </li>
            </ul>
        </div>
    );
}

export default LeftMenu;
